module.exports = __webpack_public_path__ + "static/media/jadwal.d79c61bd.png";